import React from "react";
import { Badge, Modal } from "react-bootstrap";
import { currencyFormatter } from "../../../../../../_metronic/_helpers";
import { toMonthName } from "../../../../../config/helper";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import { StatusColumnFormatter } from "../consolidation-report-table/column-formatters";
import ListGroup from "react-bootstrap/ListGroup";
import { ORGANIZATION_REPORT_STATUS } from "../ConsolidationReportUIHelpers";

export default function ConsolidationReportDetail({
  show,
  onHide,
  currentItem = {},
  handleClickStatusReport
}) {
  const {
    consolidation,
    year,
    month,
    status,
    zakat,
    infaq,
    alms,
    file_evidence_of_transfer,
    file_disbursement_form,
    file_fund_use_plan,
    file_prev_month_financial,
    file_activity_report
  } = currentItem;

  const subTotal = +zakat + +infaq + +alms;

  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <h4>Laporan Lembaga {consolidation && consolidation.name}</h4>
          <span>{StatusColumnFormatter(status)}</span>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="row">
              <div className="col">
                <div className="container mt-5">
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Tahun</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal">
                      <span>{year}</span>
                    </div>
                  </div>
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Bulan</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal">
                      <span>{toMonthName(month)}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="container mt-5">
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Zakat</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal ml-auto">
                      <span>{currencyFormatter(zakat)}</span>
                    </div>
                  </div>
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Infaq</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal ml-auto">
                      <span>{currencyFormatter(infaq)}</span>
                    </div>
                  </div>
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Sedekah</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal ml-auto">
                      <span>{currencyFormatter(alms)}</span>
                    </div>
                  </div>
                  <div className="d-flex mb-5">
                    <div className="mx-2 h6 font-weight-bold">
                      <span>Total</span>
                    </div>
                    <span>:</span>
                    <div className="mx-2 h6 font-weight-normal ml-auto">
                      <span>{currencyFormatter(subTotal)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h4>Laporan Attachment</h4>
            <div className="row">
              <div className="col">
                <ListGroup as="ol" numbered>
                  <ListGroup.Item
                    as="li"
                    className="d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">Bukti Pembayaran</div>
                    </div>
                    <a
                      onClick={() =>
                        window.open(
                          `${file_evidence_of_transfer.storage}/${file_evidence_of_transfer.path}`
                        )
                      }
                    >
                      Lihat
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item
                    as="li"
                    className="d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">Form Pencairan</div>
                    </div>
                    <a
                      onClick={() =>
                        window.open(
                          `${file_disbursement_form.storage}/${file_disbursement_form.path}`
                        )
                      }
                    >
                      Lihat
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item
                    as="li"
                    className="d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">Rencana Penggunaan Dana</div>
                    </div>
                    <a
                      onClick={() =>
                        window.open(
                          `${file_fund_use_plan.storage}/${file_fund_use_plan.path}`
                        )
                      }
                    >
                      Lihat
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item
                    as="li"
                    className="d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">
                        Laporan Keuangan Bulan Sebelumnya
                      </div>
                    </div>
                    <a
                      onClick={() =>
                        window.open(
                          `${file_prev_month_financial.storage}/${file_prev_month_financial.path}`
                        )
                      }
                    >
                      Lihat
                    </a>
                  </ListGroup.Item>
                  <ListGroup.Item
                    as="li"
                    className="d-flex justify-content-between align-items-start"
                  >
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">Laporan Kegiatan</div>
                    </div>
                    <a
                      onClick={() =>
                        window.open(
                          `${file_activity_report.storage}/${file_activity_report.path}`
                        )
                      }
                    >
                      Lihat
                    </a>
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          {currentItem.status == ORGANIZATION_REPORT_STATUS.SUBMIT && (
            <>
              <button
                className="btn btn-danger float-right"
                onClick={() => handleClickStatusReport("REJECT")}
              >
                Reject
              </button>
              <button
                className="btn btn-success float-right"
                onClick={() => handleClickStatusReport("APPROVE")}
              >
                Approve
              </button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
